// extracted by mini-css-extract-plugin
export default {"fleetRisk":"fleetRisk_fleetRisk__0j1aR","searchBox":"fleetRisk_searchBox__csphj"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fleetRisk\":\"fleetRisk_fleetRisk__0j1aR\",\"searchBox\":\"fleetRisk_searchBox__csphj\"}";
        // 1793842500987
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  